const chicagoDate = value => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Chicago",
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(date);
  const part = type => parts.find(item => item.type === type).value;
  return `${part("year")}-${part("month")}-${part("day")}`;
};

const comparisonPercent = (current, previous) => {
  if (current == null || previous == null || previous === 0) return "";
  return ((current / previous) * 100).toFixed(2);
};

export { chicagoDate, comparisonPercent };
